import React, { useState, useEffect } from 'react';

const ImageChecker = ({
  src,
  alt,
  fallbackMessage,
  className = '',
  style = {},
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  // Reset states when src changes
  useEffect(() => {
    setImageLoaded(false);
    setImageError(false);
  }, [src]);

  const handleImageLoad = () => {
    setImageLoaded(true);
    setImageError(false);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoaded(false);
  };

  const defaultStyle = {
    width: '220px',
    height: '130px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'justify',
    ...style,
  };

  // Don't render anything if no src is provided
  if (!src) {
    return (
      <div className={className} style={defaultStyle}>
        <p style={{ fontSize: '16px', color: '#8a1e1e' }}>{fallbackMessage}</p>
      </div>
    );
  }

  return (
    <div className={className} style={defaultStyle}>
      <img
        src={src}
        alt={alt}
        style={{
          display: imageLoaded && !imageError ? 'block' : 'none',
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        }}
        onLoad={handleImageLoad}
        onError={handleImageError}
      />
      {(!imageLoaded || imageError) && (
        <p style={{ fontSize: '16px', color: '#8a1e1e' }}>{fallbackMessage}</p>
      )}
    </div>
  );
};

export default ImageChecker;
